exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".link-a80ce{border:.1rem dashed rgba(0,0,0,0);border-radius:.3rem;color:#0272b6;margin:-0.4rem;outline:none;padding:.4rem;text-decoration:none;transition:border .1s ease-in,color .1s ease-in,outline .1s ease-in}.link-a80ce:hover{text-decoration:underline}.link-a80ce:active{color:#015383}.link-a80ce:focus{border:.1rem dashed #0272b6;border-radius:.3rem}.light-ad3e7{color:#2b9cd8}.light-ad3e7:hover{color:#2b9cd8}.light-ad3e7:active{color:#0272b6}.light-ad3e7:focus{border-color:#2b9cd8}", ""]);

// Exports
exports.locals = {
	"link": "link-a80ce",
	"light": "light-ad3e7"
};